import _ from 'lodash';

const ProductSubConfig = {
	initialState: {
		fields: {
			name: '',
			description: '',
			subCategoryImage: '',
			subCategoryCode: '',
			selectedCategory: null,
		},
		errors: {
			name: '',
			description: '',
			subCategoryImage: '',
			subCategoryCode: '',
			selectedCategory: '',
		},
	},
	mandatoryFields: {
		name: true,
		description: false,
		subCategoryImage: true,
		subCategoryCode: true,
		selectedCategory: true,
	},
	serializer: (state, data) => {
		return _.update(_.cloneDeep(state), 'fields', () => {
			const newState = {
				name: data.name,
				description: data.description,
				subCategoryCode: data.code,
				subCategoryImage: data.imageUrl,
				selectedCategory: data?.categoryId,
			};
			return newState;
		});
	},
	deserializer: (state) => {
		const newState = {
			name: state.fields.name,
			description: state.fields.description,
			image: state.fields.subCategoryImage,
			code: state.fields.subCategoryCode,
			categoryId: state?.fields?.selectedCategory,
		};
		return newState;
	},
};
export default ProductSubConfig;
